export type NatalieSource = 'test' | 'real';

const TEST_INVITE_CODE_PARAM = 'testInviteCode';

/**
 * Presence-based source: `test` when the URL query carries `?testInviteCode=`
 * (any value, including empty), else `real`. Query-presence only — no event
 * lookup and no path/segment branch (R6). Accepts the raw `location.search`
 * string, with or without a leading `?`.
 */
export const resolveNatalieSource = (search?: string | null): NatalieSource =>
  new URLSearchParams(search ?? '').has(TEST_INVITE_CODE_PARAM) ? 'test' : 'real';
